<template>
    <main class="signup-container">
        <header class="signup-header">
            <h1>Welcome to {{ platformName }}!</h1>
        </header>
        <section class="signup-section">
            <p class="signup-section-text">
                At {{ platformName }}, your voice matters. Freely share your thoughts and take charge of the content
                you see by directly chatting with your recommendation algorithm. Tailor your feed exactly how you
                like it.
                <br><br>
                Whether you're participating in debates or exploring fresh perspectives, our powerful tools help you
                stay informed. Counter misinformation with community notes, and sharpen your
                discussions with automated logical fallacy highlights.
                <br><br>
                And there's more, we bridge the gap between online conversations and real-world connections by
                actively promoting meetup ideas directly within the app. Join us in shaping a vibrant community
                where ideas flourish, debates thrive, and genuine connections are made.
            </p>
            <div class="signup-form">
                <h3>Enter a username to get started</h3>
                <input type="text" v-model="username" />
                <p>
                    (Use digits, lowercase letters, and underscores only, min 4 and max 16 chars)
                </p>
                <p class="error-msg">
                    {{ errorMsg }}
                </p>
                <button @click="createUser">Create new account</button>
            </div>
        </section>
    </main>
</template>


<script>
import { getPlatformName, defaultErrorMsg, validateUsername } from '@/util.js';
import UserService from '@/service/user.js';

export default {
    name: 'SignUp',
    data() {
        return {
            userService: new UserService(),
            defaultErrorMsg: defaultErrorMsg(),
            platformName: getPlatformName(),
            username: '',
            errorMsg: '',
        };
    },
    methods: {
        async createUser() {
            // validate username
            let errorMsg = validateUsername(this.username);
            if (errorMsg !== null) {
                this.errorMsg = errorMsg;
                return;
            }

            // send create user request
            let res = await this.userService.createUser(this.username);

            // handle response
            if (res.error === null) {
                this.$router.push(`/home`);
            } else if (res.error === "") {
                alert(this.defaultErrorMsg);
            } else {
                this.errorMsg = res.error;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.signup-container {
    /* --- layout --- */
    min-height: 100vh;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    text-align: center;
    background: url('../assets/signup_bg.jpg') center/cover no-repeat;
    margin: 0;
    width: 100%;

    /* --- theme --- */
    background-color: #000;
    font-size: 16px;
    color: #fff;

    .signup-header {
        /* --- layout --- */
        padding: 3rem;

        /* --- theme --- */
        font-family: 'Papyrus', fantasy;
    }

    .signup-section {
        .signup-section-text {
            /* --- layout --- */
            display: flex;
            flex-direction: column;
            padding: 2rem;
        }

        .signup-form {
            /* --- layout --- */
            display: flex;
            flex-direction: column;
            padding: 2rem;
            justify-content: center;
            align-items: center;
            text-align: center;

            input {
                /* --- layout --- */
                min-width: 200px;
                max-width: 400px;
                border: none;
                border-radius: 10px;
                height: 2rem;
                text-align: center;
            }

            input:focus {
                /* --- layout --- */
                outline: none;
            }

            .error-msg {
                /* --- layout --- */
                display: flex;
                justify-content: center;
                height: 15px;
                padding: 5px;
                margin: 5px;

                /* --- theme --- */
                color: #f55;
                font-size: 12px;
            }

            button {
                /* --- layout --- */
                border: none;
                padding: 10px 16px;
                text-align: center;
                border-radius: 6px;

                /* --- theme --- */
                background-color: #024;
                color: white;
                text-decoration: none;
                font-size: 16px;
                cursor: pointer;
                transition: background-color 0.3s ease;
            }

            button:hover {
                /* --- theme --- */
                background-color: #048;
                transition: background-color 0.3s ease;
            }
        }
    }
}

@media (max-width: 768px) {
    .signup-container {
        flex-direction: column;
    }
}
</style>
